import { EuiEmptyPrompt } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { DistributionPerPUbblicationDate } from 'sections/Charts/DistributionPerPubblicationDate';
import { SellingTimeForBrandNamesChart } from 'sections/Charts/SellingTimeForBrandNamesChart';
import { SellingTimeForCarBodiesChart } from 'sections/Charts/SellingTimeForCarBodies';
import { SellingTimeForPowerSuppliesChart } from 'sections/Charts/SellingTimeForPowerSuppliesChart';

export const DashboardCharts = ({ vendorNames }: { vendorNames: string[] | undefined }): JSX.Element | null => {
  const { formatMessage } = useIntl();
  return !vendorNames?.length ? (
    <EuiEmptyPrompt iconType="tableOfContents" body={formatMessage({ id: 'competitors.missing-vendorNames' })} />
  ) : (
    <>
      <SellingTimeForBrandNamesChart vendorNames={vendorNames} />
      <SellingTimeForPowerSuppliesChart vendorNames={vendorNames} />
      <SellingTimeForCarBodiesChart vendorNames={vendorNames} />
      <DistributionPerPUbblicationDate vendorNames={vendorNames} />
    </>
  );
};
